
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import ProductRepository from '@/repositories/webshop/ProductRepository';
import ProductTranslationRepository from '@/repositories/webshop/ProductTranslationRepository';
import CouponRepository from '@/repositories/webshop/CouponRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class CouponFormScreen extends Vue {
    @Inject()
    private readonly couponRepository!: CouponRepository;
    @Inject()
    private readonly productRepository!: ProductRepository;
    @Inject()
    private readonly productTranslationRepository!: ProductTranslationRepository;

    public get embeds() {
        return [
            {
                relationship: 'products',
                parentRefKey: 'productId',
                i18nGroup: 'couponProducts',
                entityRepository: this.productRepository,
                columns: ['id', 'defaultName', 'articleNumber'],
                embeds: {
                    relationship: 'translations',
                    parentRefKey: 'productId',
                    i18nGroup: 'productTranslation',
                    entityRepository: this.productTranslationRepository,
                    columns: ['lang', 'name'],
                },
            },
        ];
    }
}
